import { useTranslation } from 'react-i18next'
import type { AnalysisMode } from './AnalysisModeCards'

export type OutputMode = 'audit' | 'full'

const AUDIT_CREDITS: Record<AnalysisMode, number> = { small: 180, standard: 300, custom: 300 }
const IMAGE_CREDITS = 500

// eslint-disable-next-line react-refresh/only-export-components -- utility function co-located with component
export function calcCredits(mode: AnalysisMode, output: OutputMode): number {
  return AUDIT_CREDITS[mode] + (output === 'full' ? IMAGE_CREDITS : 0)
}

interface CreditPreviewProps {
  mode: AnalysisMode
  output: OutputMode
}

export function CreditPreview({ mode, output }: CreditPreviewProps) {
  const { t } = useTranslation()
  const total = calcCredits(mode, output)
  const auditCr = AUDIT_CREDITS[mode]

  return (
    <div className="campaign-creator-credits flex items-center justify-end gap-2 text-xs text-neutral-500 dark:text-neutral-400">
      <span className="flex items-center gap-1">
        <span className="inline-block h-1.5 w-1.5 rounded-full bg-primary-500" aria-hidden="true" />
        {t('campaignCreator.credits.audit', { count: auditCr })}
      </span>
      {output === 'full' && (
        <span className="flex items-center gap-1">
          <span className="inline-block h-1.5 w-1.5 rounded-full bg-primary-500" aria-hidden="true" />
          {t('campaignCreator.credits.images', { count: IMAGE_CREDITS })}
        </span>
      )}
      <span className="rounded-lg border border-neutral-200 dark:border-neutral-700 bg-neutral-100 dark:bg-neutral-800 px-2.5 py-0.5 font-bold text-neutral-900 dark:text-white text-sm">
        {total} {t('campaignCreator.credits.unit')}
      </span>
    </div>
  )
}
